export const BASE_URL = `${process.env.REACT_APP_API_URL}/api/v1`;
export const ONBOARDING_BASE_URL = `${process.env.REACT_APP_API_URL}/api/v1/onboarding`;
